
import { useNotificationsRealtime } from "./notifications/useNotificationsRealtime";
import { useNotificationsCounts } from "./notifications/useNotificationsCounts";
import { useNotificationsData } from "./notifications/useNotificationsData";
import { useNotificationsFiltering } from "./notifications/useNotificationsFiltering";
import { SupabaseNotification } from "@/types/notifications";

export type { SupabaseNotification };

/**
 * Main hook for notifications list functionality, combining data fetching,
 * real-time updates, filtering, sorting, and counts
 */
export const useNotificationsList = (viewMode: "active" | "archived") => {
  // Set up real-time subscription first to ensure it's active
  // before any data fetching
  useNotificationsRealtime(viewMode);
  
  // Get notification counts
  const {
    activeNotificationsCount,
    archivedNotificationsCount,
    unreadNotificationsCount
  } = useNotificationsCounts();
  
  // Fetch notifications data with reduced stale time
  const {
    notifications,
    isLoading,
    error
  } = useNotificationsData(viewMode);
  
  // Set up filtering and sorting with improved search capabilities
  const {
    searchTerm,
    setSearchTerm,
    filteredNotifications,
    sortedNotifications,
    sortConfig,
    requestSort
  } = useNotificationsFiltering(notifications);

  return {
    // Data
    notifications,
    filteredNotifications,
    sortedNotifications,
    
    // Loading and error states
    isLoading,
    error,
    
    // Search and sort
    searchTerm,
    setSearchTerm,
    sortConfig,
    requestSort,
    
    // Counts
    activeNotificationsCount,
    archivedNotificationsCount,
    unreadNotificationsCount
  };
};
